import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@atlaskit/button/new";
import { getBackupFile } from "../redux/actions/backupRestoreActions";
const DownloadFlow = ({ backupFileRef, filename }) => {
  const backup = useSelector((state) => state.backups.backup);

  const dispatch = useDispatch();
  const [lastRequestedFile, setLastRequestedFile] = useState(null);

  useEffect(() => {
    if (backupFileRef && backup && lastRequestedFile === backupFileRef) {
      const blob = new Blob([JSON.stringify(backup)], { type: "application/json" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${filename}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLastRequestedFile(null); // Reset to prevent repeated triggering
    }
  }, [backup, backupFileRef, filename, lastRequestedFile]);

  const downloadClick = () => {
    setLastRequestedFile(backupFileRef);
    dispatch(getBackupFile(backupFileRef));
  };

  return (
    <Button onClick={downloadClick} appearance="link">
      {filename}
    </Button>
  );
};

export default DownloadFlow;
